import { useEffect, useState } from "react";
import modalState from "../../../state-observables/modal/ModalState";
import styles from "./styles.module.css";

import { HiOutlineLightBulb } from "react-icons/hi";
import { MdQrCode } from "react-icons/md";

//@ts-ignore
import { Scanner, centerText, IDetectedBarcode } from '@yudiel/react-qr-scanner';
import { CogStateInfo, ConnManager } from "@robotical/roboticaljs";
import { useTranslation } from "react-i18next";

type Option = {
  id: "qr" | "led";
  title: string;
  subtitle: string;
  icon: JSX.Element;
};

export default function LEDLightsOrQRVerificationModal() {
  const { t } = useTranslation();
  const [qrSelected, setQRSelected] = useState(true);
  const [serialNoFromQR, setSerialNoFromQR] = useState<string | undefined>(undefined);
  const [isButtonToConnectVisible, setIsButtonToConnectVisible] = useState(false);
  
  useEffect(() => {
    if (serialNoFromQR) {
      // 00000000202502200000000000000239
      console.log("serialNoFromQR", serialNoFromQR)
      console.log("ConnManager.generateServiceFilterUUID(serialNoFromQR)", ConnManager.generateServiceFilterUUID(serialNoFromQR))
      const dd = ConnManager;
      // modalState.closeModalWithoutAnimation([ConnManager.generateServiceFilterUUID(serialNoFromQR)]);
      // modalState.closeModalWithoutAnimation([ConnManager.generateServiceFilterUUID('00000000202302111d28b4dc5f0d46d5')]);
      setIsButtonToConnectVisible(true);
      setQRSelected(false);
    }
  }, [serialNoFromQR]);
  
  const options: Option[] = [
    {
      id: "qr",
      title: t('connection.qr_title'),
      subtitle: t('connection.qr_subtitle'),
      icon: <MdQrCode size={32} />,
    },
    {
      id: "led",
      title: t('connection.led_title'),
      subtitle: t('connection.led_subtitle'),
      icon: <HiOutlineLightBulb size={32} />,
    },
  ];

  const handleSelect = (id: 'qr' | 'led') => {
    if (id === 'qr') {
      setSerialNoFromQR(undefined);
      setQRSelected(prev => !prev);
      // modalState.closeModalWithoutAnimation([ConnManager.generateServiceFilterUUID('00000000202502200000000000000239')]);
    } else {
      console.log("LED Lights Verification");
      modalState.closeModalWithoutAnimation([]);
    }
  };

  const handleConnect = async () => {
    if (serialNoFromQR) {
      modalState.closeModalWithoutAnimation([ConnManager.generateServiceFilterUUID(serialNoFromQR)]);
    } else {
      // // testing
      // modalState.closeModalWithoutAnimation([ConnManager.generateServiceFilterUUID('00000000000000000000000000000079')]);
    }
  };

  return (
    <div className={styles.container}>
      {!isButtonToConnectVisible ? <div className={styles.cards}>
        {options.map(({ id, title, subtitle, icon }) => (
          <div key={id}
            className={qrSelected && id === 'qr' ? [styles.card, styles.qrselected].join(" ") : styles.card}
            onClick={() => handleSelect(id)}>
            <div className={styles.icon}>{icon}</div>
            <h3 className={styles.title}>{title}</h3>
            <p className={styles.subtitle}>{subtitle}</p>
          </div>
        ))}
      </div> : 
      <div className={styles.cogNote}>
        <strong>Don't forget to <span className={styles.cogNoteHighlight}>turn on</span> your Cog!</strong>
      </div>}
      {qrSelected && <QRContent setSerialNo={setSerialNoFromQR} />}
      <div className={styles.buttonsContainer}>
        {isButtonToConnectVisible && <button className={styles.connectButton} onClick={handleConnect}>{t('connection.qr_connect_button')}</button>}
        <button className={styles.cancelButton} onClick={() => modalState.closeModal(false)}>{t('connection.cancel')}</button>
      </div>
    </div>
  );
}



type Props = {
  setSerialNo: React.Dispatch<React.SetStateAction<string | undefined>>;
};

function QRContent({ setSerialNo }: Props) {

  const onQrCodeFound = async (result: IDetectedBarcode[]) => {
    const rawValue = result[0]?.rawValue;

    if (!rawValue || !rawValue.includes("CV1-")) {
      window.applicationManager.toaster.error("No Valid QR Code Found");
      return;
    }

    // const today = new Date();
    // const serialNo = "00000000" + today.toISOString().split("T")[0].replaceAll("-", "") + rawValue.split("-").slice(-1)[0].padStart(16, "0");
    const serialNo = "00000000" + rawValue.split("-").slice(-1)[0].padStart(24, "0");
    setSerialNo(serialNo);
  };
  const isWebapp = window.applicationManager.deviceInfo?.manufacturer === "Webapp";
  return (
    <div className={styles.QRcontainer}>
      <div className={styles.QRscannerContainer}>
        <Scanner
          styles={{ container: { transform: isWebapp ? 'scaleX(-1)' : 'none' } }}
          onError={(err) => console.error(err)}
          formats={[
            "qr_code",
            "micro_qr_code",
            "rm_qr_code",
            "maxi_code",
            "pdf417",
            "aztec",
            "data_matrix",
            "matrix_codes",
            "dx_film_edge",
            "databar",
            "databar_expanded",
            "codabar",
            "code_39",
            "code_93",
            "code_128",
            "ean_8",
            "ean_13",
            "itf",
            "linear_codes",
            "upc_a",
            "upc_e",
          ]}
          allowMultiple={false}
          scanDelay={2000}
          onScan={onQrCodeFound}
          components={{
            audio: true,
            onOff: false,
            torch: true,
            zoom: true,
            finder: true,
            tracker: centerText, // boundingBox // outline //
          }}
        />
      </div>
    </div>
  );
}